module.exports = __webpack_public_path__ + "static/media/thad.4ed2b56b.png";